<template>
  <DragDialog
    title="查看坐标系"
    :width="400"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="closeDialog"
  >
    <div class="coordinates-box">
      <div class="type-box">
        <div class="label">坐标系类型：</div>
        <div class="value">{{ coordinatesInfo.coordinatesType }}</div>
      </div>
      <div class="crs-content-box">
        <div class="label">场景坐标系：</div>
        <div class="common-input-box">
          <el-input
          class="input-primary"
            size="medium"
            type="textarea"
            placeholder="注释信息"
            :rows="5"
            :maxlength="2000"
            show-word-limit
            :value="coordinatesInfo.coordinates"
            readonly
          />
        </div>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from "@/components/CustomDragDialog.vue";
export default {
  props: {
    visible: Boolean,
    coordinatesInfo: Object,
    closeDialog: Function,
  },
  components: { DragDialog },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";
.coordinates-box {
  color: var(--page-text-color);
  font-size: 14px;
  font-weight: 400;
  padding-bottom: 16px;

  .label {
    width: 88px;
    text-align: right;
  }

  .type-box {
    display: flex;
  }

  .crs-content-box {
    display: flex;
    margin-top: 10px;
  }
}
</style>